import React, { Component } from 'react';
import { Row, Col, Button, Card, CardBody } from 'reactstrap';
import { withRouter } from 'react-router';
import _ from 'underscore';
import { Global } from '~/App'
import API from '~/API';
import GriddleCasero from '~/components/GriddleCasero'
import moment from 'moment';
import { Link } from 'react-router-dom';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar } from 'recharts';

class Documentos extends Component {
    constructor() {
        super();
        this.state = {
            collapsed: false,
            datos: [],
            cargando: true
        }
        this.ConsultaDocumentos = this.ConsultaDocumentos.bind(this)
        this.getDocumento = this.getDocumento.bind(this)
    }
    async getDocumento(idProceso, noDoc) {
        var win = window.open('about:blank', '_blank');
        if (win) {
            win.document.write(`
                <html>
                    <head>
                        <title>Cargando documento...</title>
                        <style>
                            body {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                height: 100vh;
                                margin: 0;
                                font-family: Arial, sans-serif;
                                background-color: #f9f9f9;
                            }
                            .spinner {
                                border: 8px solid #f3f3f3;
                                border-top: 8px solid #3498db;
                                border-radius: 50%;
                                width: 60px;
                                height: 60px;
                                animation: spin 1s linear infinite;
                            }
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                            .loading-text {
                                margin-top: 20px;
                                font-size: 18px;
                                color: #555;
                            }
                        </style>
                    </head>
                    <body>
                        <div>
                            <div class="spinner"></div>
                            <div class="loading-text">Cargando documento...</div>
                        </div>
                    </body>
                </html>
            `);
            win.document.close();
        }
    
        try {
            var datos = await API.Call(`Consulta/${this.props.Servicio.empresa}/Documento/${this.props.Servicio.idServicio}/${idProceso}/${noDoc}`);
        } catch {
            win.close();
            return;
        }
    
        if (!win.closed) {
            var byteCharacters = atob(datos);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            let file = new Blob([byteArray], { type: "application/pdf;base64" });
    
            // Reemplazar el contenido de la ventana con el PDF
            win.document.body.innerHTML = ''; // Limpia el contenido previo (spinner, texto)
            var blobHtmlElement = document.createElement('object');
            blobHtmlElement.style.position = 'fixed';
            blobHtmlElement.style.top = '0';
            blobHtmlElement.style.left = '0';
            blobHtmlElement.style.bottom = '0';
            blobHtmlElement.style.right = '0';
            blobHtmlElement.style.width = '100%';
            blobHtmlElement.style.height = '100%';
            blobHtmlElement.setAttribute('type', 'application/pdf');
            blobHtmlElement.setAttribute('data', URL.createObjectURL(file));
    
            win.document.title = 'Documento Tributario Electrónico';
            win.document.body.appendChild(blobHtmlElement);
        }
    }
    componentWillMount() {
        this.Redirect(this.props);
        this.ConsultaDocumentos(this.props);
    }
    componentWillReceiveProps(props) {
        this.Redirect(props)
        if (this.props.Servicio.empresa != props.Servicio.empresa || this.props.Servicio.idServicio !== props.Servicio.idServicio) {
            this.ConsultaDocumentos(props);
        }
    }
    Redirect(props) {
        if (!this.props.Servicio.idServicio) {
            props.history.replace("/sucursal")
        }
    }
    async ConsultaDocumentos(props) {
        if (!props.Servicio.idServicio || !props.Servicio.empresa) {
            return;
        }
        this.setState({ cargando: true })
        var datos = await API.Call(`Consulta/${props.Servicio.empresa}/Cartola/Documentos/${props.Servicio.idServicio}/${moment().add(-13, 'month').format("DDMMYYYY")}/${moment().add(1, 'month').format("DDMMYYYY")}`);
        datos = _.map(datos, e => {
            e.fechaformato = moment(e.fecha).format("MMM YYYY")
            e.monto = e.debe - e.haber
            return e;
        }).reverse()
        this.setState({ datos, cargando: false });
    }
    render() {

        const imprimibleFormatter = ({ rowData }) => {
            var idProceso = rowData.id_proceso;
            var noDoc = rowData.numero;
            return <div className="text-center">
                <Button onClick={() => this.getDocumento(idProceso, noDoc)} color="primary" size="sm">
                    <i className="fa fa-download" /> Descargar
                </Button>
            </div>;
        };
        const pagableFormatter = ({ value, griddleKey, rowData }) => {
            return rowData.aPagar > 0 ?
                value ?
                    <div className="text-center">
                        <Button tag={Link} to={{
                            pathname: "/paga",
                            state: { orden: griddleKey, servicio: this.props.Servicio.idServicio, empresa: this.props.Servicio.empresa }
                        }} color="primary" size="sm" block>Pagar
                        </Button>
                    </div> :
                    <div className="text-center">
                        <Button size="sm" color="primary" disabled block>No disponible</Button>
                    </div> : null;
        };
        const fechaFormatter = ({ value, columnId, rowData }) => {
            value = value ? moment(value) : null;
            return <div className={"text-sm-left" + (columnId == "fecha_vcto" && value < moment() && rowData.aPagar > 0 ? " text-danger" : "")}>{value ? value.format("DD/MM/YYYY") : null}</div>;
        };
        const columns = [
            { key: "nombre_movimiento", name: "Documento" },
            { key: "fechaformato", name: "Periodo" },
            { key: "fecha_vcto", name: "Vencimiento", formatter: fechaFormatter },
            { key: "monto", name: "Total Documento", right: true, formatter: "dinero" },
            { key: "aPagar", name: "Total Deuda", right: true, formatter: "dinero" },
            { key: "id", name: " ", formatter: imprimibleFormatter },
            { key: "pagable", name: " ", formatter: pagableFormatter }
        ];
        var rows = _.sortBy(this.state.datos || [], d => moment(d.fecha)).reverse();
        return (
            <div>
                <Row>
                    <Col sm={12}>
                        <div className={this.state.cargando ? "progress-bar progress-bar-striped progress-bar-animated bg-secondary" : ""} style={{ height: "1rem", marginTop: "-1rem" }}><small>{this.state.cargando ? "Cargando" : ""}</small></div>
                        <ResponsiveContainer width={"100%"} height={250}>
                            <BarChart width={730} height={250} data={this.state.datos}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="fechaformato" />
                                <YAxis tickFormatter={t => ("$ " + Global.FormatearNumero(t))} />
                                <Tooltip formatter={(value, name, props) => [<strong>{"$ " + Global.FormatearNumero(value)}</strong>, props.payload.nombre_movimiento]} />
                                <Bar dataKey="monto" className="grafico-barras1" />
                            </BarChart>
                        </ResponsiveContainer>
                        <hr />
                        <br />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className="bordeIzquierdo">
                        {/* Vista para escritorio y tablet */}
                        <div className="d-none d-md-block">
                            <GriddleCasero
                                data={rows}
                                columns={columns}
                            />
                        </div>

                        {/* Vista para móviles */}
                        <div className="d-md-none">
                            {this.state.datos?.length ? (
                                rows.map((item, index) => (
                                    <Card key={index} className="mb-3">
                                        <CardBody>
                                            <p><i className="fa fa-file-text-o mr-2" /><strong>Documento:</strong> {item.nombre_movimiento}</p>
                                            <p><i className="fa fa-calendar mr-2" /><strong>Periodo:</strong> {item.fechaformato}</p>
                                            <p><i className="fa fa-calendar-times-o mr-2" /><strong>Vencimiento:</strong> {item.fecha_vcto ? moment(item.fecha_vcto).format("DD/MM/YYYY") : 'N/A'}</p>
                                            <p><i className="fa fa-money mr-2" /><strong>Total Documento:</strong> ${Global.FormatearNumero(item.monto)}</p>
                                            <p><i className="fa fa-money mr-2" /><strong>Total Deuda:</strong> ${Global.FormatearNumero(item.aPagar)}</p>
                                            <div className="mt-3">
                                                <Button onClick={() => this.getDocumento(item.id_proceso, item.numero)} color="primary" size="sm" block>
                                                    <i className="fa fa-download mr-1" /> Descargar
                                                </Button>
                                                {item.aPagar > 0 && (
                                                    item.pagable ? (
                                                        <Button tag={Link} to={{
                                                            pathname: "/paga",
                                                            state: { orden: item.griddleKey, servicio: this.props.Servicio.idServicio, empresa: this.props.Servicio.empresa }
                                                        }} color="primary" size="sm" block className="mt-2">Pagar
                                                        </Button>
                                                    ) : (
                                                        <Button size="sm" color="primary" disabled block className="mt-2">No disponible</Button>
                                                    )
                                                )}
                                            </div>
                                        </CardBody>
                                    </Card>
                                ))
                            ) : (
                                <p className="text-center text-muted">No se encontraron documentos.</p>
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}


export default withRouter(Documentos);